import bem from '../../../utils/bem';

const ItemMetaData = ({ items, mods, extraClasses }) => {
  const baseClass = 'item-meta-data';

  const renderItems = items?.map((item, index) => {
    return (
      <li className={bem('item', [], baseClass)} key={index}>
        {item}
      </li>
    );
  });

  return (
    <ul className={bem(baseClass, mods || [], '', extraClasses || [])}>
      {renderItems}
    </ul>
  );
};

export default ItemMetaData;
